module.exports = __webpack_public_path__ + "img/slide_003_t.30017bfa.jpg";